import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16.3 16.3",
	style: { enableBackground: "new 0 0 16.3 16.3" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.play-circle-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "play-circle-icon-st0",
		d: "M8.1,0C6.5,0,4.9,0.5,3.6,1.4C2.3,2.3,1.2,3.5,0.6,5s-0.8,3.1-0.5,4.7c0.3,1.6,1.1,3,2.2,4.2s2.6,1.9,4.2,2.2 c1.6,0.3,3.2,0.2,4.7-0.5c1.5-0.6,2.8-1.7,3.6-3c0.9-1.3,1.4-2.9,1.4-4.5c0-2.2-0.9-4.2-2.4-5.7C12.3,0.9,10.3,0,8.1,0z M11,8.6 l-3.8,2.5c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2s-0.1-0.2-0.1-0.3v-5c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.1-0.2,0.2-0.2C6.7,5,6.8,5,6.9,5C7,5,7.1,5,7.2,5.1L11,7.6c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3 C11.1,8.5,11.1,8.6,11,8.6z"
	})]
});
export default SvgPlayCircleIcon;
